import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = "https://zvctooatydqejpekbvlj.supabase.co"
const SUPABASE_KEY = "sb_publishable_Mf9Ysvsx1adoOt1NKxzBpw_JLWuwc8-"

export const supabase = createClient(SUPABASE_URL, SUPABASE_KEY)

